// extracted by mini-css-extract-plugin
export default {"sessionSelector":"DlApZJreUaRG8I5jX86JT"};